import React, { useState } from "react";
import { toastr } from "react-redux-toastr";
import { Controller, useForm } from "react-hook-form";
import { DropdownList } from "react-widgets";
import ErrorMessage from "../../components/text/ErrorMessage";
import { Phone, EmailAddress, Designation } from "../../core/api/models";
import CustomerPhone from "../../components/customer-phone";
import CustomerEmail from "../../components/customer-email";
import { UploadUserImage } from "../../components/upload";
import title from "../../utils/title.json";
import "react-widgets/dist/css/react-widgets.css";
import api from "../../api";
import {
    CheckPhoneNumberEmpty,
    ValidateAlphabets,
    ValidateEmail,
    Validate965DigitPhoneNumber,
    ValidateDigitString,
} from "../../utils/Validatation";
import moment from "moment";
import { useDataLoader } from "react-remote-data-hooks";

interface LandLordForm {
    photo?: any;
    prefix?: string;
    firstName?: string;
    lastName?: string;
    phones?: Phone[];
    emails?: EmailAddress[];
    designationId?: string;
}

const AddLandLordUserModal: React.FunctionComponent<{
    error?: string;
    onCreateUser?: () => void;
    phones?: Phone[];
    emails?: EmailAddress[];
    onClose: () => void;
    propertyId?: string;
}> = (props) => {
    const [isEmailEnable, setIsEmailEnable] = useState<boolean>(true);
    const [isSubmiting, setIsSubmiting] = useState<boolean>(false);
    const [selectedPhone, setSelectedPhone] = useState<Phone[] | undefined>(
        props.phones
    );
    const [selectedEmail, setSelectedEmail] = useState<
        EmailAddress[] | undefined
    >(props.emails);

    const [isEmailOrPhone, setIsEmailOrPhone] = useState<boolean>(false);

    // const { data: designations } = useDataLoader<Designation[]>(() =>
    //     api.designation.loadAllDesignation()
    // );

    const {
        control,
        handleSubmit,
        errors,
        clearErrors,
        watch,
        setValue,
        trigger,
        reset
    } = useForm<LandLordForm>({
        reValidateMode: "onChange",
        mode: "onSubmit",
    });

    const onSubmit = async (fdata?: any) => {
        const hasEmailOrPhone = () => {
            if (!selectedEmail && selectedPhone && selectedPhone?.every((x) => x?.phone === x?.dialCode || x?.phone === '')) {
                setIsEmailOrPhone(true)
                return false
            } else if (!selectedPhone && selectedEmail && selectedEmail?.every((sm) => sm.email === '')) {
                setIsEmailOrPhone(true)
                return false
            } else if (selectedPhone && selectedEmail && selectedPhone?.every((x) => x.phone === x.dialCode || x.phone === '') && selectedEmail?.every((sm) => sm.email === '')) {
                setIsEmailOrPhone(true)
                return false
            } else if (!selectedPhone && !selectedEmail) {
                setIsEmailOrPhone(true)
                return false
            } else {
                setIsEmailOrPhone(false)
                return true
            }
        }

        if (hasEmailOrPhone()) {
            setIsSubmiting(true);
            const updateData: LandLordForm = {
                prefix: fdata?.prefix,
                firstName: fdata?.firstName,
                lastName: fdata?.lastName,
                phones: selectedPhone?.filter((x) => CheckPhoneNumberEmpty(x.phone)),
                emails: selectedEmail?.filter((x) => ValidateEmail(x.email)),
                photo: fdata.photo,
                // designationId: fdata.designation,
            };
            try {
                await api.sitevisit.addNewLandLord(props?.propertyId!, updateData);
                props?.onCreateUser?.();
                toastr.success("Success", "User added successfully");
                props?.onClose?.()
                setIsSubmiting(false);
            } catch (error) {
                toastr.error("Error", error?.response?.data?.message);
                setIsSubmiting(false);
            }
            // try {
            //     await api.customer.createCustomer(updateData);
            //     props?.onCreateUser?.();
            //     toastr.success("Success", "User added successfully");
            //     props?.onClose?.()
            //     setIsSubmiting(false);
            // } catch (error) {
            //     toastr.error("Error", error?.response?.data?.message);
            //     setIsSubmiting(false);
            // }
        }
    }

    const onChangePhone = (phoneNumber: Phone[]) => {
        setSelectedPhone(phoneNumber);
        // setIsEmailOrPhone(false)
        clearErrors("phones");
    };

    const onChangeEmail = (emailAdd: EmailAddress[]) => {
        setSelectedEmail(emailAdd);
        // setIsEmailOrPhone(false)
        clearErrors("emails");

    };

    return (
        <form onSubmit={handleSubmit(onSubmit)}>
            <div className="p-4">
                <div className="form-group d-flex flex-wrap align-items-center">
                    <Controller
                        control={control}
                        name="photo"
                        render={({ onChange, value, name }) => (
                            <UploadUserImage
                                id={"photo"}
                                title={"Add Photo"}
                                onChange={onChange}
                            />
                        )}
                    />
                </div>
                <div className="form-group font-weight-semibold mb-4">
                    <label htmlFor="" className="font-sm text-uppercase">
                        Title<span className="text-danger">*</span>
                    </label>
                    <Controller
                        control={control}
                        rules={{ required: true }}
                        name="prefix"
                        // defaultValue={props.customerDetails?.prefix}
                        render={({ onChange, value, name }) => (
                            <DropdownList
                                value={value}
                                defaultValue={value}
                                data={title}
                                textField={"name"}
                                valueField={"name"}
                                placeholder={"Select prefix"}
                                onChange={(val) => {
                                    onChange(val.name);
                                }}
                            />
                        )}
                    />
                    {errors.prefix && <ErrorMessage>Prefix is required</ErrorMessage>}
                </div>
                <div className="form-group font-weight-semibold mb-4">
                    <label htmlFor="" className="font-sm text-uppercase">
                        First Name<span className="text-danger">*</span>
                    </label>

                    <Controller
                        control={control}
                        rules={{
                            required: true,
                            validate: (value) => {
                                return !!ValidateAlphabets(value);
                            },
                            maxLength: 25,
                        }}
                        name="firstName"
                        render={({ onChange, value, name }) => (
                            <input
                                type="text"
                                className="form-control rounded-sm font-weight-semibold"
                                placeholder="First Name"
                                name={name}
                                value={value}
                                onChange={onChange}
                                id="firstName"
                            />
                        )}
                    />
                    {errors.firstName && errors.firstName.type === "required" && (
                        <ErrorMessage>First Name is required</ErrorMessage>
                    )}
                    {errors.firstName && errors.firstName.type === "maxLength" && (
                        <ErrorMessage>
                            First name should contains maximum 25 characters
                        </ErrorMessage>
                    )}
                    {errors.firstName && errors.firstName.type === "validate" && (
                        <ErrorMessage>Invalid First Name</ErrorMessage>
                    )}
                </div>
                <div className="form-group font-weight-semibold mb-4">
                    <label htmlFor="" className="font-sm text-uppercase">
                        Last Name
                        {/* <span className="text-danger">*</span> */}
                    </label>
                    <Controller
                        control={control}
                        // rules={{
                        //     required: true,
                        //     validate: (value) => {
                        //         return !!ValidateAlphabets(value);
                        //     },
                        //     maxLength: 25,
                        // }}
                        name="lastName"
                        render={({ onChange, value, name }) => (
                            <input
                                type="text"
                                className="form-control rounded-sm font-weight-semibold"
                                placeholder="Last Name"
                                name={name}
                                value={value}
                                onChange={onChange}
                                id="lastName"
                            />
                        )}
                    />
                    {errors.lastName && errors.lastName.type === "required" && (
                        <ErrorMessage>Last Name is required</ErrorMessage>
                    )}
                    {errors.lastName && errors.lastName.type === "maxLength" && (
                        <ErrorMessage>
                            Last name should contains maximum 25 characters
                        </ErrorMessage>
                    )}
                    {errors.lastName && errors.lastName.type === "validate" && (
                        <ErrorMessage>Invalid Last Name</ErrorMessage>
                    )}
                </div>
                <div className="form-group font-weight-semibold mb-4">
                    <label htmlFor="" className="font-sm text-uppercase">
                        Phone
                    </label>
                    <Controller
                        control={control}
                        // rules={{
                        //     required: true,
                        //     validate: (value) => {
                        //         return !(
                        //             !selectedPhone ||
                        //             (selectedPhone &&
                        //                 selectedPhone?.filter((x) =>
                        //                     Validate965DigitPhoneNumber(x.phone)
                        //                 ).length !== selectedPhone?.length)
                        //         );
                        //     },
                        // }}
                        rules={{
                            // required: true,
                            validate: (value) => {
                                if (selectedPhone?.length && selectedPhone?.every((x) => x.phone === x.dialCode || x.phone === `+${x.dialCode}` || x.phone === '')) {
                                    return true
                                }
                                return !(
                                    // !selectedPhone ||
                                    (selectedPhone &&
                                        selectedPhone?.filter((x) =>
                                            Validate965DigitPhoneNumber(x.phone)
                                        ).length !== selectedPhone?.length)
                                );
                            },
                        }}
                        name="phones"
                        defaultValue={props.phones}
                        render={({ onChange, value, name }) => (
                            <CustomerPhone
                                className="form-control p-0 rounded-sm font-weight-semibold"
                                placeholder="Phone"
                                value={selectedPhone}
                                onChange={(val) => {
                                    onChangePhone(val);
                                    onChange(val);
                                }}
                            />
                        )}
                    />
                    {errors.phones && (
                        <div>
                            <div>
                                {!selectedPhone ? (
                                    <ErrorMessage>Valid Phone is required</ErrorMessage>
                                ) : (
                                    <>
                                        {selectedPhone?.filter(
                                            (x) =>
                                                !!(
                                                    x.phone.startsWith("91") || x.phone.startsWith("+91")
                                                )
                                        ).length > 0 ? (
                                            <ErrorMessage>
                                                Phone number should be 10 digits
                                            </ErrorMessage>
                                        ) : (
                                            <ErrorMessage>Invalid Phone number</ErrorMessage>
                                        )}
                                    </>
                                )}
                            </div>
                        </div>
                    )}
                </div>
                <div className="form-group font-weight-semibold mb-4">
                    <label
                        htmlFor=""
                        className="font-sm text-uppercase d-flex align-items-end"
                    >
                        Email
                        {/* <div className="ml-auto switch switch--sm">
                            <input
                                type="checkbox"
                                name=""
                                onChange={(val) => {
                                    setIsEmailEnable(!isEmailEnable);
                                    if (isEmailEnable) {
                                        clearErrors("emails");
                                    }
                                }}
                                id="emailSwitch"
                                checked={isEmailEnable}
                            />
                            <label htmlFor="emailSwitch">
                                <div className="switch-handle mr-2"></div>
                            </label>
                        </div> */}
                    </label>
                    <Controller
                        control={control}
                        rules={{
                            // required: true,              
                            validate: (value) => {
                                if (selectedEmail?.length && selectedEmail?.every((x) => !x.email)) {
                                    return true
                                } else {
                                    return !(
                                        (
                                            // !selectedEmail ||
                                            (selectedEmail &&
                                                selectedEmail?.filter((x) => ValidateEmail(x.email))
                                                    .length === 0)) &&
                                        isEmailEnable
                                    )
                                }
                            },
                            // required:
                            //   (!selectedEmail ||
                            //     (selectedEmail &&
                            //       selectedEmail?.filter((x) => ValidateEmail(x.email))
                            //         .length === 0)) &&
                            //   isEmailEnable,
                        }}
                        name="emails"
                        defaultValue={props.emails}
                        render={({ onChange, value, name }) => (
                            <CustomerEmail
                                className="form-control p-0 rounded-sm font-weight-semibold"
                                placeholder="Email"
                                value={selectedEmail}
                                onChange={onChangeEmail}
                                disabled={!isEmailEnable}
                            />
                        )}
                    />
                    {errors.emails && (
                        <div>
                            <ErrorMessage>Valid email is required</ErrorMessage>
                        </div>
                    )}
                </div>

                {/* <div className="form-group font-weight-semibold mb-4">
                    <label htmlFor="" className="font-sm text-uppercase">
                        Designation
                    </label>
                    <Controller
                        control={control}
                        rules={{ required: true }}
                        name="designation"
                        // defaultValue={props?.customerDetails?.designation?._id}
                        render={({ onChange, value, name }) => (
                            <input
                                type="text"
                                className="form-control rounded-sm font-weight-semibold"
                                placeholder="Designation"
                                name={name}
                                value={value}
                                onChange={onChange}
                                id="Designation"
                            />                           
                        )}
                    />
                    {errors.designation && (
                        <ErrorMessage>Designation is required</ErrorMessage>
                    )}
                </div> */}

                {/* <div className="form-group font-weight-semibold mb-4">
                    <label htmlFor="" className="font-sm text-uppercase">
                        Designation
                    </label>
                    <Controller
                        control={control}
                        // rules={{ required: true }}
                        name="designation"
                        // defaultValue={props?.customerDetails?.designation?._id}
                        render={({ onChange, value, name }) => (
                            <DropdownList
                                value={value}
                                defaultValue={value}
                                data={designations?.map((key) => {
                                    return {
                                        _id: key._id,
                                        name: key.name,
                                    };
                                })}
                                textField={"name"}
                                valueField={"_id"}
                                placeholder={"Select Designation"}
                                onChange={(val) => {
                                    onChange(val._id);
                                }}
                            />
                        )}
                    />
                    {errors.designation && (
                        <ErrorMessage>Designation is required</ErrorMessage>
                    )}
                </div> */}


                {isEmailOrPhone ? (
                    <ErrorMessage>At least one of email or phone is required</ErrorMessage>
                ) : ''}
                <div className="col-12 font-normal font-weight-semibold pt-3 mb-2 border-top mt-3 pb-5">
                    <button
                        type="button"
                        onClick={() => {
                            reset();
                            props.onClose?.();
                        }}
                        className="btn btn-outline-secondary font-base font-weight-bold mr-2 px-4 rounded"
                    >
                        Cancel
                    </button>
                    <button
                        type="submit"
                        className="btn btn-primary font-base font-weight-bold px-5 rounded"
                        disabled={isSubmiting}
                    >
                        Add User
                    </button>
                    <br />
                    {/* {!isFormChanged && <ErrorMessage>No changes were found</ErrorMessage>} */}
                </div>
            </div>
        </form>
    );
};

export default AddLandLordUserModal;
